import type React from "react"
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner"

interface LoadingViewProps {
  title?: string
  description?: string
}

const LoadingView: React.FC<LoadingViewProps> = ({
  title = "Loading Configuration",
  description = "Please wait while we prepare your sync setup...",
}) => (
  <div className="review-sync-setup">
    <div className="loading-container">
      <LoadingSpinner size="large" />
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  </div>
)

export default LoadingView
